import React from 'react';

interface Props {
    className?: string;
    children?: JSX.Element|(JSX.Element[]);
}

const ButtonGroup = ({
    className = '',
    children = null,
}: Props) => <div className={`btn-group ${className}`}>
    {children}
</div>;

export default ButtonGroup;
